import React from "react";

const COLORS = {
  // backups
  healthy:  { text: "text-emerald-400", bg: "bg-emerald-500/15", border: "border-emerald-500/40", dot: "healthy",  label: "HEALTHY" },
  success:  { text: "text-emerald-400", bg: "bg-emerald-500/15", border: "border-emerald-500/40", dot: "healthy",  label: "SUCCESS" },
  warning:  { text: "text-amber-400",   bg: "bg-amber-500/15",   border: "border-amber-500/40",   dot: "warning",  label: "WARNING" },
  failure:  { text: "text-red-400",     bg: "bg-red-500/15",     border: "border-red-500/40",     dot: "failure",  label: "FAILURE" },
  missed:   { text: "text-slate-300",   bg: "bg-slate-500/20",   border: "border-slate-500/40",   dot: "missed",   label: "MISSED"  },
  unknown:  { text: "text-slate-300",   bg: "bg-slate-500/20",   border: "border-slate-500/40",   dot: "unknown",  label: "UNKNOWN" },
  // monitors
  up:       { text: "text-emerald-400", bg: "bg-emerald-500/15", border: "border-emerald-500/40", dot: "up",       label: "UP"      },
  down:     { text: "text-red-400",     bg: "bg-red-500/15",     border: "border-red-500/40",     dot: "down",     label: "DOWN"    },
  degraded: { text: "text-amber-400",   bg: "bg-amber-500/15",   border: "border-amber-500/40",   dot: "degraded", label: "DEGRADED"},
  pending:  { text: "text-slate-300",   bg: "bg-slate-500/20",   border: "border-slate-500/40",   dot: "pending",  label: "PENDING" },
  paused:   { text: "text-slate-300",   bg: "bg-slate-500/20",   border: "border-slate-500/40",   dot: "paused",   label: "PAUSED"  },
};

export default function StatusBadge({ status, size = "sm" }) {
  const k = (status || "unknown").toLowerCase();
  const c = COLORS[k] || COLORS.unknown;
  const padding = size === "lg" ? "px-3 py-1.5 text-xs" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={`status-badge-${k}`}
      className={`inline-flex items-center gap-1.5 uppercase tracking-wider rounded-md border ${c.text} ${c.bg} ${c.border} ${padding}`}
    >
      <span className={`status-dot ${c.dot}`} />
      {c.label}
    </span>
  );
}
